// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-links__wrapper[data-v-8e1a02a2]{display:none}", ""]);
// Exports
module.exports = exports;
